import { PartnerConfig } from "src/app/core/interfaces/partner-config";

export const Partner: PartnerConfig = {
  id: 'systems',
  title: {
    de: 'Systems SysBiz',
    it: 'Systems SysBiz',
    en: 'Systems SysBiz'
  },
  portalUrl: 'https://bs.systems.bz',
  apiUrl: 'https://bs-api.systems.bz',
  oldPortalUrl: 'https://bs.systems.bz/-/',
  jobServiceUrl: 'https://job.systems.bz/jobs',
  backlink: true,
  pathPrefix: '',
  bankingVersionCookie: { name: 'portal-version-banking', domain: '.systems.bz' },
  documentSignerVersionCookie: { name: 'portal-version-documentsigner', domain: '.systems.bz' },
  postboxVersionCookie: { name: 'portal-version-postbox', domain: '.systems.bz' },
  conservationVersionCookie: { name: 'portal-version-conservation', domain: '.systems.bz' },
  ssoRedirectPage: "https://sso.systems.bz/1cf6b81c-543e-4aef-8a00-966c3035d2f9",
}

